// @ts-nocheck

/**
 *
 * Recursively maps through keys of an object and transforms the key name using the provided transform function
 */
export const deepMapKeys = (obj: any[], fn: (key: string) => any) => {
  return Array.isArray(obj)
    ? obj.map((val) => deepMapKeys(val, fn))
    : typeof obj === 'object'
    ? Object.keys(obj).reduce((acc, current) => {
        const key = fn(current);
        const val = obj[current];
        acc[key] = val !== null && typeof val === 'object' ? deepMapKeys(val, fn) : val;
        return acc;
      }, {})
    : obj;
};
